export const sheep = [
    "Lincoln",
    "Dorset",
    "Turcana",
    "Dorper sheep",
    "Tsigai",
    "Hampshire sheep",
    "Suffolk",
    "East Friesian",
]